<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <ref-o-k-e-i-table :mode="'compact'"  :value="value" @input="setValue" @onCloseWindow="doClose"></ref-o-k-e-i-table>
  </v-dialog>
</template>

<script>
import RefOKEITable from '@/components/modules/references/refOKEITable'

export default {
  name: 'refOKEISelectDialog',
  components: { RefOKEITable },
  props: ['OKEI', 'value'],
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    setValue (val) {
      this.$emit('onOKEIChanged', val)
      this.doClose()
    },
    doClose () {
      this.$emit('input', false)
    }
  },
  mounted () {
    console.log('refOKEISelectDialog mounted with OKEI ', this.OKEI)
  }
}
</script>
